myUrlPath = "https://backend.relibridgeminerals.com"
// myUrlPath = "http://192.168.2.208:8000"
